import { useNotificationsContext } from "common/context/NotificationsProvider"
import { infiniteScrollHandler } from "common/utils/utils"
import { nanoid } from "nanoid"
import { ProgressSpinner } from "primereact/progressspinner"
import NotificationsMenuItem from "./NotificationsMenuItem"

import "../style.scss"

const NotificationsMenuList = () => {
  const {
    // @ts-expect-error TS(2339): Property 'unReadNotifications' does not exist on t...
    unReadNotifications,
    // @ts-expect-error TS(2339): Property 'setNotificationsQueryState' does not exi...
    setNotificationsQueryState,
    // @ts-expect-error TS(2339): Property 'unReadNotificationsLoading' does not exi...
    unReadNotificationsLoading,
  } = useNotificationsContext()
  const { queryState, list, totalCount } = unReadNotifications

  const getMoreNotifications = () => {
    const newQueryState = {
      ...queryState,
      skipCount: queryState.skipCount + queryState.maxResultCount,
    }
    setNotificationsQueryState(newQueryState, true)
  }

  return (
    <div
      onScroll={(event) =>
        infiniteScrollHandler(
          event,
          queryState.skipCount,
          queryState.maxResultCount,
          totalCount,
          getMoreNotifications
        )
      }
      className='notifications-menu-list d-flex flex-column'
    >
      {list.map((notification: $TSMigrationFixMe) => (
        <NotificationsMenuItem
          key={nanoid()}
          notification={notification}
        />
      ))}
      {unReadNotificationsLoading && (
        <div className='w-100 h-100 d-flex align-items-center'>
          <ProgressSpinner />
        </div>
      )}
    </div>
  )
}

export default NotificationsMenuList
